module.exports = __webpack_public_path__ + "static/media/md-print.3c09a2bb.svg";